export default __webpack_public_path__ + "static/media/ReviewsSearchTimer.69cc23ad.svg";